module.exports = __webpack_public_path__ + "static/media/agenda-dia.1f20c6a5.svg";